import Axios from 'axios'
import store from '@/store/index.js'
import { cultureCheck } from '@/utils/cultureCheck'

const url = new URL(window.location.href)
const pathSegments = url.pathname.split('/').filter(segment => segment !== '')

const validLanguages = ['fr', 'es', 'tr']
const lang = validLanguages.includes(pathSegments[0]) ? pathSegments[0] : ''

const VALID_URL = `${url.origin}/${lang ? `${lang}/` : ''}api-v2/`

const API_URL = `${VALID_URL}portal`
const UISTRINGS_URL = `${VALID_URL}uistrings`
const LOG_URL = `${VALID_URL}log`

Axios.defaults.withCredentials = true
export class APIService {
  exception (message) {
    const params = new URLSearchParams()
    params.append('message', message)
    const url = `${LOG_URL}/exception`
    return Axios.post(url, params)
  }

  login (credentials) {
    const params = new URLSearchParams()
    params.append('culture', cultureCheck())
    params.append('email', credentials.email)
    params.append('password', credentials.pw)
    const url = `${API_URL}/login`
    return Axios.post(url, params)
  }

  internalLogin (credentials) {
    const params = new URLSearchParams()
    params.append('culture', cultureCheck())
    params.append('contactId', credentials.contactId)
    params.append('internalUser', credentials.internalUser)
    const url = `${API_URL}/internallogin`
    return Axios.post(url, params)
  }

  refreshDossier () {
    const params = new URLSearchParams()
    params.append('culture', cultureCheck())
    const url = `${API_URL}/refreshdossier`
    return Axios.post(url, params)
  }

  logout () {
    const url = `${API_URL}/logout`
    return Axios.get(url)
  }

  updateAccount () {
    const url = `${API_URL}/updateAccount`
    const params = new URLSearchParams()
    const account = store.getters['account/shadowAccount']
    params.append('Id', store.getters['account/getAccountId'])
    params.append('FirstName', account.FirstName)
    params.append('MiddleName', account.MiddleName)
    params.append('LastName', account.LastName)
    params.append('PostalCode', account.PostalCode)
    params.append('HouseNumber', account.HouseNumber)
    params.append('HouseNumberExtension', account.HouseNumberExtension)
    params.append('StreetName', account.StreetName)
    params.append('City', account.City)
    params.append('CountryCode', account.CountryCode)
    params.append('PhoneNumber', account.PhoneNumber)
    params.append('EMailAddress', account.EMailAddress)
    return Axios.post(url, params)
  }

  updateLogin (data) {
    const url = `${API_URL}/updateLogin`
    const params = new URLSearchParams()
    params.append('oldPassword', data.oldPassword)
    params.append('newPassword', data.newPassword)
    return Axios.post(url, params)
  }

  acceptTerms () {
    const url = `${API_URL}/acceptterms`
    return Axios.post(url, {})
  }

  requestPoaHardcopy (data) {
    const url = `${API_URL}/requestpoahardcopy`
    return Axios.post(url, data)
  }

  requestPasswordChange (data) {
    const url = `${API_URL}/requestPasswordChange`
    return Axios.post(url, data)
  }

  checkPasswordRequest (data) {
    const url = `${API_URL}/checkPasswordRequest`
    return Axios.post(url, data)
  }

  createNewPassword (data) {
    const url = `${API_URL}/createNewPassword`
    return Axios.post(url, data)
  }

  getClaim (id) {
    const url = `${API_URL}/getClaim`
    const params = new URLSearchParams()
    params.append('Id', id)
    params.append('culture', cultureCheck())
    return Axios.post(url, params)
  }

  updatePerson (data) {
    const url = `${API_URL}/updatePassengers`
    return Axios.post(url, data)
  }

  addPassenger (data) {
    const url = `${API_URL}/addPassenger`
    return Axios.post(url, data)
  }

  addNonPassenger (data) {
    const url = `${API_URL}/addNonPassenger`
    return Axios.post(url, data)
  }

  confirmAction (data) {
    const url = `${API_URL}/confirmaction`
    return Axios.post(url, data)
  }

  downloadFile (data) {
    const url = `${API_URL}/download`
    return Axios.post(url, data, { responseType: 'blob' })
  }

  downloadAttachment (data) {
    const url = `${API_URL}/downloadattachment`
    return Axios.post(url, data, { responseType: 'blob' })
  }

  downloadOverview (data) {
    const url = `${API_URL}/downloadoverview`
    return Axios.post(url, data, { responseType: 'blob' })
  }

  sendMessage (data) {
    const url = `${API_URL}/sendmessage`
    return Axios.post(url, data)
  }

  createReview (data) {
    const url = `${API_URL}/createreview`
    return Axios.post(url, data)
  }

  updateReview (data) {
    const url = `${API_URL}/updatereview`
    return Axios.post(url, data)
  }

  getEmail (data) {
    const url = `${API_URL}/getemail`
    return Axios.post(url, data)
  }

  getSupportedFileTypes () {
    const url = `${API_URL}/supportedfiletypes`
    return Axios.get(url)
  }

  uploadFiles (data) {
    const url = `${API_URL}/uploadfiles`
    return Axios.post(url, data.formData)
  }

  deleteDocument (data) {
    const url = `${API_URL}/deletedocument`
    return Axios.post(url, data)
  }

  uploadReceipts (data) {
    const url = `${API_URL}/sendreceipts`
    return Axios.post(url, data.formData)
  }

  deleteReceipt (data) {
    const formData = new FormData()
    formData.append('receiptId', data.documentId)
    formData.append('receiptClaimId', data.claimId)
    const url = `${API_URL}/deletereceipt`
    return Axios.post(url, formData)
  }

  convertCurrency (data) {
    const formData = new FormData()
    formData.append('amount', data.amount)
    formData.append('currency', data.currency)
    const url = `${API_URL}/convertcurrency`
    return Axios.post(url, formData)
  }

  findAddress (data) {
    const url = `${API_URL}/findaddress`
    return Axios.post(url, data)
  }

  updatePaymentMethod (data) {
    const url = `${API_URL}/updatepaymentmethod`
    return Axios.post(url, data)
  }

  requiredBankAccountFields (data) {
    const url = `${API_URL}/bankaccountfields`
    return Axios.post(url, data)
  }

  updateBankAccountDetails (data) {
    const url = `${API_URL}/updatebankaccount`
    return Axios.post(url, data)
  }

  updatePayPalEmail (data) {
    const url = `${API_URL}/updatepaypalaccount`
    return Axios.post(url, data)
  }

  fetchPortalStrings (language) {
    const url = `${UISTRINGS_URL}/portal/${language}`
    return Axios.get(url)
  }

  fetchGeneralStrings (language) {
    const url = `${UISTRINGS_URL}/general/${language}`
    return Axios.get(url)
  }

  checkLogin () {
    const url = `${API_URL}/isloggedin`
    return Axios.get(url)
  }
}
